"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgorithmIdentifier = void 0;
exports.urlEncodeBase64 = urlEncodeBase64;
exports.generateHash = generateHash;
/**
 *
 * @param {string} str The string to URL-encode
 * @returns {string} The URL-encoded string
 */
function urlEncodeBase64(str) {
    return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
/**
 * Algorithm identifiers for hashing
 */
var AlgorithmIdentifier;
(function (AlgorithmIdentifier) {
    /**
     * Secure Hash Algorithm 256
     */
    AlgorithmIdentifier["SHA_256"] = "SHA-256";
    /**
     * Secure Hash Algorithm 384
     */
    AlgorithmIdentifier["SHA_384"] = "SHA-384";
    /**
     * Secure Hash Algorithm 512
     */
    AlgorithmIdentifier["SHA_512"] = "SHA-512";
    /**
     * Plain text (not recommended for security reasons)
     * @deprecated Avoid using plain. Use `SHA_256` or stronger algorithms instead.
     */
    AlgorithmIdentifier["PLAIN"] = "plain";
})(AlgorithmIdentifier || (exports.AlgorithmIdentifier = AlgorithmIdentifier = {}));
const DEFAULT_HASH_OPTIONS = { algo: AlgorithmIdentifier.SHA_256, urlSafe: false };
/**
 * Generates a hash of the given string using specified hashing options.
 *
 * @param {string} str - The string to hash.
 * @param {HashOptions} [options] - Optional hashing options to customize the process.
 * @param {AlgorithmIdentifier} [options.algo] - The hashing algorithm to use (default: AlgorithmIdentifier.SHA_256).
 * @param {boolean} [options.urlSafe] - Whether the output should be URL-safe (default: false).
 * @returns {Promise<string>} - The hashed string, optionally URL-safe.
 */
async function generateHash(str, options) {
    const { algo, urlSafe } = Object.assign({}, DEFAULT_HASH_OPTIONS, options);
    if (algo === AlgorithmIdentifier.PLAIN) {
        return urlSafe ? urlEncodeBase64(str) : str;
    }
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const digest = await crypto.subtle.digest(algo, data);
    const base64 = Buffer.from(new Uint8Array(digest)).toString('base64');
    return urlSafe ? urlEncodeBase64(base64) : base64;
}
